<template>
  <div class="tabs">
    <vs-tabs :color="tabColor" position="left" alignment="fixed">
      <vs-tab label="Data Hub" icon="dns">
        <div class="tab-panel">
          <!-- Switch between forms view or graphs  -->
          <btm-datahub-search
            v-show="btmDatahubActivePanel == DATAHUB.SEARCH"
          />
          <btm-datahub-viewer v-if="btmDatahubActivePanel == DATAHUB.VIEWER" />
          <!-- Navigation button -->
          <div
            v-show="btmDatahubActivePanel !== DATAHUB.SEARCH"
            class="back-button"
          >
            <vs-button
              type="flat"
              icon="keyboard_arrow_left"
              @click="goToDataHubForm()"
              >Back to form</vs-button
            >
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Blue Growth" icon="attach_money">
        <div class="tab-panel">
          <btm-blue-search
            v-show="btmBlueGrowthActivePanel == BLUEGROWTH.SEARCH"
          />
          <btm-blue-viewer
            v-if="btmBlueGrowthActivePanel == BLUEGROWTH.VIEWER"
          />
          <!-- Navigation button -->
          <div
            v-show="btmBlueGrowthActivePanel !== BLUEGROWTH.SEARCH"
            class="back-button"
          >
            <vs-button
              type="flat"
              icon="keyboard_arrow_left"
              @click="goToBlueGrowthForm()"
              >Back to form</vs-button
            >
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Tools" icon="build">
        <div class="tab-panel">
          <btm-tools-search v-show="btmToolsActivePanel === TOOLS.SEARCH" />
          <btm-tools-viewer
            v-if="btmToolsActivePanel === TOOLS.VIEWER"
            :hindcast-result="hindcastDataResult"
          />
          <btm-tools-results v-if="btmToolsActivePanel === TOOLS.RESULTS" />
          <div
            v-show="btmToolsActivePanel !== TOOLS.SEARCH"
            class="back-button"
          >
            <vs-button
              type="flat"
              icon="keyboard_arrow_left"
              @click="goToToolsForm()"
              >Back to form</vs-button
            >
          </div>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>
<script>
import TheBTMDataHubSearch from "@/views/BlueTimeMachine/TheBTMDataHubSearch";
import TheBTMDataHubViewer from "@/views/BlueTimeMachine/TheBTMDataHubViewer";
import TheBTMBlueGrowthSearch from "@/views/BlueTimeMachine/TheBTMBlueGrowthSearch";
import TheBTMBlueGrowthViewer from "@/views/BlueTimeMachine/TheBTMBlueGrowthViewer";
import TheBTMToolsSearch from "@/views/BlueTimeMachine/TheBTMToolsSearch";
import TheBTMToolsResults from "@/views/BlueTimeMachine/TheBTMToolsResults";
import TheBTMToolsViewer from "@/views/BlueTimeMachine/TheBTMToolsViewer";
import { BTM_PANELS } from "@/constants.js";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    "btm-datahub-search": TheBTMDataHubSearch,
    "btm-datahub-viewer": TheBTMDataHubViewer,
    "btm-blue-search": TheBTMBlueGrowthSearch,
    "btm-blue-viewer": TheBTMBlueGrowthViewer,
    "btm-tools-search": TheBTMToolsSearch,
    "btm-tools-results": TheBTMToolsResults,
    "btm-tools-viewer": TheBTMToolsViewer
  },
  data() {
    return {
      tabColor: "#19535F",
      DATAHUB: BTM_PANELS.DATAHUB,
      BLUEGROWTH: BTM_PANELS.BLUEGROWTH,
      TOOLS: BTM_PANELS.TOOLS
    };
  },
  computed: {
    ...mapState({
      hindcastDataResult: state => state.hindcastDataResult,
      btmDatahubActivePanel: state => state.btmDatahubActivePanel,
      btmBlueGrowthActivePanel: state => state.btmBlueGrowthActivePanel,
      btmToolsActivePanel: state => state.btmToolsActivePanel
    })
  },
  methods: {
    ...mapActions({
      setBTMDataHubActivePanel: "setBTMDataHubActivePanel",
      setBTMBlueGrowthActivePanel: "setBTMBlueGrowthActivePanel",
      setBTMToolsActivePanel: "setBTMToolsActivePanel"
    }),
    goToDataHubForm() {
      this.setBTMDataHubActivePanel(BTM_PANELS.DATAHUB.SEARCH);
    },
    goToBlueGrowthForm() {
      this.setBTMBlueGrowthActivePanel(BTM_PANELS.BLUEGROWTH.SEARCH);
    },
    goToToolsForm() {
      this.setBTMToolsActivePanel(BTM_PANELS.TOOLS.SEARCH);
    }
  }
};
</script>
<style scoped>
.con-slot-tabs {
  flex: 1;
}
.con-vs-tabs >>> .con-slot-tabs {
  width: 100%;
}

.con-vs-tabs >>> .vs-icon {
  font-size: 1.3rem;
}

.con-vs-tabs >>> button {
  font-size: 0.8rem;
}

.con-vs-tabs >>> .vs-tabs--btn {
  min-width: 140px;
}

.tab-panel {
  display: flex;
  justify-content: flex-start;
  flex-grow: 1;
  justify-content: center;
  min-height: 330px;
  overflow: auto;
  max-height: 575px;
  flex-wrap: wrap;
}
.vs-tabs-position-left .con-ul-tabs {
  padding-top: 10px;
}
.back-button {
  display: flex;
  justify-content: flex-start;
  margin-top: 0.5rem;
  margin-left: 1rem;
  flex-grow: 1;
}
</style>
